

















/* General */
import Vue from 'vue'
import schema from 'async-validator'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

/* This component should be used as a standard email input. It comes with...
   1) Red validation border if the email is not valid, upon blur
   2) Option to validate email if user goes back to blank (after first typing)
   3) Emits:
      * valid - When current value is a valid email
      * invalid - When current value is an invalid email
      * valid-on-blur - When value is a valid email on blur
      * invalid-on-blur - When value is an invalid email on blur
*/
export default Vue.extend({
  name: 'StandardEmailInput',

  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    validateIfBlank: {
      type: Boolean,
      default: false,
    },
    showToLabel: {
      type: Boolean,
      default: false,
    },
    focusField: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      invalid: false,
      showError: false,
    }
  },

  computed: {
    internalValue: {
      get(): String | Number {
        return this.value
      },
      set(value: any): any {
        this.$emit('input', value)
      },
    },
    showEmailValidationIcon(): Boolean {
      return Boolean(this.internalValue)
    },
  },

  watch: {
    focusField(value: boolean) {
      if (value) {
        // @ts-ignore
        this.$refs.inputRef.focus()
      }
    },
    internalValue(value: string) {
      if (value === null) {
        return false
      }

      const validator = new schema({
        email: {
          type: 'email',
          required: this.validateIfBlank,
        },
      })
      validator.validate(
        { email: value.trim() },
        (errors: any, fields: any) => {
          this.invalid = errors ? true : false
          if (!errors) {
            this.$emit('valid')
          } else {
            this.$emit('invalid')
          }
        },
      )
    },
  },

  methods: {
    updateShowError() {
      this.showError = this.invalid
      this.invalid ? this.$emit('invalid-on-blur') : this.$emit('valid-on-blur')
    },
  },
})
